import MuiThemeProvider from '@mui/system/ThemeProvider';
import { themeLight } from '@theme/mui/muiTheme';
import { PropsWithChildren } from 'react';

export const LightTheme = (props: PropsWithChildren) => {
  return <MuiThemeProvider theme={themeLight} {...props} />;
};
